export const statusMap: Record<string, string[]> = {
  submitted: ['SubmittedByCustomer'],
  draft: ['AddingItems'],
  accepted: ['Approved'],
  orders: [],
};
